module.exports = __webpack_public_path__ + "assets/web-active.037f2fcc.svg";